export { isBeforeToday } from "../../../common/utils/dateUtil";

export function formatUTCDateString(dateString: string): string {
    return new Date(dateString).toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
        timeZone: "UTC"
    });
}
